export default "__VITE_ASSET__wkY$nyDe__"